import { Skeleton, StanCard } from '@/components';

/**
 * Skeleton loading state that mimics the appearance of the recipients tab
 */
export const RecipientsTabSkeleton = () => {
    return (
        <StanCard className='relative'>
            {/* Actions menu placeholder */}
            <div className='absolute top-4 right-4'>
                <Skeleton className='size-8 rounded-md' />
            </div>

            {/* Title - matches h3 "Recipients" */}
            <Skeleton className='mb-4 h-7 w-24' />

            {/* Filter section */}
            <div className='mb-4'>
                {/* "Filter Recipients" label */}
                <Skeleton className='mb-3 h-4 w-28' />
                {/* Filter chips - matches StanFilters layout */}
                <div className='flex flex-wrap items-start gap-3'>
                    <Skeleton className='h-8 w-28 rounded-full' />
                    <Skeleton className='h-8 w-24 rounded-full' />
                    <Skeleton className='h-8 w-32 rounded-full' />
                    <Skeleton className='h-8 w-20 rounded-full' />
                </div>
            </div>

            {/* Table - matches StanTable structure */}
            <div className='w-full'>
                {/* Table header */}
                <div className='border-neutral-subtle grid grid-cols-[1fr_1fr_auto] border-b'>
                    <div className='px-4 py-3'>
                        <Skeleton className='h-4 w-12' />
                    </div>
                    <div className='px-4 py-3'>
                        <Skeleton className='h-4 w-12' />
                    </div>
                    <div className='px-4 py-3 text-right'>
                        <Skeleton className='ml-auto h-4 w-12' />
                    </div>
                </div>

                {/* Table rows */}
                {Array.from({ length: 9 }).map((_, index) => (
                    <div
                        key={index}
                        className='border-neutral-subtle grid grid-cols-[1fr_1fr_auto] items-center border-b'
                    >
                        {/* Name column */}
                        <div className='px-4 py-5'>
                            <Skeleton className='h-4 w-28' />
                        </div>
                        {/* Email column */}
                        <div className='px-4 py-3'>
                            <Skeleton className='h-4 w-40' />
                        </div>
                        {/* Status badge column */}
                        <div className='flex justify-end px-4 py-3'>
                            <Skeleton className='h-6 w-20 rounded-full' />
                        </div>
                    </div>
                ))}
            </div>

            {/* Table footer - matches StanTable pagination */}
            <div className='flex w-full items-center justify-between px-4 py-4'>
                {/* Total rows label */}
                <Skeleton className='h-4 w-36' />
                {/* Pagination info */}
                <div className='flex items-center gap-1'>
                    <Skeleton className='h-5 w-20' />
                    <Skeleton className='size-6' />
                    <Skeleton className='size-6' />
                </div>
            </div>
        </StanCard>
    );
};
